import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { comboDetailsFragment } from "./queries";
import {
  ComboAddProducts,
  ComboAddProductsVariables
} from "./types/ComboAddProducts";
import {
  ComboBulkEnable,
  ComboBulkEnableVariables
} from "./types/ComboBulkEnable";
import { ComboCreate, ComboCreateVariables } from "./types/ComboCreate";
import { ComboDelete, ComboDeleteVariables } from "./types/ComboDelete";
import {
  ComboRemoveProducts,
  ComboRemoveProductsVariables
} from "./types/ComboRemoveProducts";
import {
  ComboReorderProducts,
  ComboReorderProductsVariables
} from "./types/ComboReorderProducts";
import { ComboUpdate, ComboUpdateVariables } from "./types/ComboUpdate";

const comboCreate = gql`
  ${comboDetailsFragment}
  mutation ComboCreate($input: ComboInput!) {
    comboCreate(input: $input) {
      combo {
        ...ComboDetailsFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useComboCreateMutation = makeMutation<
  ComboCreate,
  ComboCreateVariables
>(comboCreate);

const comboUpdate = gql`
  ${comboDetailsFragment}
  mutation ComboUpdate($id: ID!, $input: ComboInput!) {
    comboUpdate(id: $id, input: $input) {
      combo {
        ...ComboDetailsFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useComboUpdateMutation = makeMutation<
  ComboUpdate,
  ComboUpdateVariables
>(comboUpdate);

const comboAddProducts = gql`
  ${comboDetailsFragment}
  mutation ComboAddProducts($id: ID!, $productIds: [ID]!) {
    comboAddProducts(id: $id, productIds: $productIds) {
      combo {
        ...ComboDetailsFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useComboAddProductsMutation = makeMutation<
  ComboAddProducts,
  ComboAddProductsVariables
>(comboAddProducts);

const comboRemoveProducts = gql`
  ${comboDetailsFragment}
  mutation ComboRemoveProducts($id: ID!, $productIds: [ID]!) {
    comboRemoveProducts(id: $id, productIds: $productIds) {
      combo {
        ...ComboDetailsFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useComboRemoveProductsMutation = makeMutation<
  ComboRemoveProducts,
  ComboRemoveProductsVariables
>(comboRemoveProducts);

const comboReorderProducts = gql`
  ${comboDetailsFragment}
  mutation ComboReorderProducts($move: MoveComboProductInput!, $comboId: ID!) {
    comboReorderProducts(moves: [$move], comboId: $comboId) {
      combo {
        ...ComboDetailsFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useComboReorderProductsMutation = makeMutation<
  ComboReorderProducts,
  ComboReorderProductsVariables
>(comboReorderProducts);

const comboBulkEnable = gql`
  mutation ComboBulkEnable($ids: [ID]!, $enable: Boolean) {
    comboBulkEnable(ids: $ids, enable: $enable) {
      errors {
        field
        message
      }
    }
  }
`;
export const useComboBulkEnableMutation = makeMutation<
  ComboBulkEnable,
  ComboBulkEnableVariables
>(comboBulkEnable);

const comboDelete = gql`
  mutation ComboDelete($id: ID!) {
    comboDelete(id: $id) {
      errors {
        field
        message
      }
    }
  }
`;

export const useComboDeleteMutation = makeMutation<
  ComboDelete,
  ComboDeleteVariables
>(comboDelete);
